<template>
    <div>
        <form @submit.prevent="add">
            <div class="form-row">
                <div class="col-sm-8 mb-1 mb-sm-0">
                    <textarea class="form-control" rows="2" v-model="text" id="text" :class="{ 'is-invalid': form.errors.has('text') }" placeholder="Текст напоминания"></textarea>
                    <has-error :form="form" field="text"/>
                </div>
                <div class="col-sm-4">
                    <div class="form-group mb-1">
                        <el-date-picker
                            v-model="expires_at"
                            type="datetime"
                            placeholder="Select date and time"
                            :clearable="false"
                            :size="'small'"
                            :value-format="'yyyy-MM-dd HH:mm:ss'"
                            :picker-options="pickerOptions"
                            :class="{ 'is-invalid': form.errors.has('expires_at') }"
                        ></el-date-picker>
                        <has-error :form="form" field="expires_at"/>
                    </div>
                    <div class="form-group">
                        <v-button :loading="form.busy" :large="false" :type="'primary'" :class="'btn-block'">Добавить</v-button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import VButton from "../../Button";
    import Form from 'vform';
    import toastr from "toastr";
    let dateFormat = require('dateformat');

    export default {
        name: "AddRequestReminder",
        components: {VButton},
        props: ['request'],
        data: () => ({
            text: '',
            expires_at: null,
            form: new Form(),
            pickerOptions: {
                firstDayOfWeek: 1,
                shortcuts: [
                    {
                        text: 'Через 30 мин',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + (1000 * 60 * 30));
                            picker.$emit('pick', date);
                        }
                    },
                    {
                        text: 'Через час',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + (1000 * 60 * 60));
                            picker.$emit('pick', date);
                        }
                    },
                    {
                        text: 'Через 2ч',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + (1000 * 60 * 60 * 2));
                            picker.$emit('pick', date);
                        }
                    },
                    {
                        text: 'Через 3ч',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + (1000 * 60 * 60 * 3));
                            picker.$emit('pick', date);
                        }
                    },
                    {
                        text: 'Через 6ч',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + (1000 * 60 * 60 * 3));
                            picker.$emit('pick', date);
                        }
                    },
                    {
                        text: 'Через сутки',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() + (1000 * 60 * 60 * 24));
                            picker.$emit('pick', date);
                        }
                    }
                ],
            },
        }),
        mounted() {
            this.expires_at = dateFormat(new Date(), 'yyyy-mm-dd HH:MM:ss');
        },
        methods: {
            async add () {
                if (this.validate()) {
                    this.form.request_id = this.request.id;
                    this.form.text = this.text;
                    this.form.expires_at = this.expires_at;

                    const {data} = await this.form.post('/api/request_reminders');
                    this.text = '';
                    this.expires_at = dateFormat(new Date(), 'yyyy-mm-dd HH:MM:ss');

                    toastr.success('Создано напоминание');
                    this.$bus.$emit('request.' + this.request.id + '.reminder:create');
                }
            },
            validate: function () {
                this.form = new Form();
                if (this.text.length <= 0) {
                    this.form.errors.set('text', ['Текст не может быть пустым']);
                    return false;
                }
                if (this.expires_at.length <= 0) {
                    this.form.errors.set('expires_at', ['Дата не может быть пустой']);
                    return false;
                }
                return  true;
            },
        }
    }
</script>

<style scoped>

</style>
